import { Controller } from '@hotwired/stimulus'
import { put } from '../lib/request'
import { on } from '../lib/events'

export default class extends Controller {
  static values = { url: String, inCollection: Boolean }

  connect = () => {
    this.isProduct = false
    on('product:dragged', this.setIsProduct)
    this.element.addEventListener('dragenter', this.handleDragEnter)
    this.element.addEventListener('dragleave', this.handleDragLeave)
    this.element.addEventListener('drop', this.handleDrop)
  }

  setIsProduct = (event) => {
    this.isProduct = event.detail.type === 'products'
  }

  handleDragEnter = (event) => {
    if (event.dataTransfer.types.includes('Files')) return

    event.stopPropagation()
    event.preventDefault()
    if (this.isProduct) {
      this.element.classList.add('dragEntered')
      this.element.style.backgroundColor = 'rgb(107 114 128)'
    }
  }

  handleDragLeave = (event) => {
    if (event.dataTransfer.types.includes('Files')) return

    event.stopPropagation()
    event.preventDefault()
    if (this.isProduct) {
      this.element.classList.remove('dragEntered')
      this.element.style.backgroundColor = ''
    }
  }

  handleDrop = (event) => {
    if (event.dataTransfer.types.includes('Files')) return

    if (this.isProduct) {
      const draggingProductId = event.dataTransfer.getData('text/plain')
      const product = document.querySelector(`[data-currently-dragging="${draggingProductId}"]`)

      product.removeAttribute('data-currently-dragging')

      this.element.style.backgroundColor = ''
      product.classList.remove('dragEntered')
      this.element.classList.remove('dragEntered')

      this.highlightDrop()

      put(this.urlValue, {
        body: this.params(product),
        responseKind: 'turbo-stream',
      })
    }
  }

  params = (product) => {
    return {
      id: this.collectionId,
      product_id: product.dataset.productId,
      in_collection: this.inCollectionValue,
    }
  }

  highlightDrop = () => {
    this.element.classList.add('border-4', 'border-4', 'border-indigo-500', 'ease-in', 'duration-150')
    setTimeout(() => {
      this.element.classList.remove('border-4', 'border-4', 'border-indigo-500')
    }, 500)
  }

  get collectionId() {
    return this.element.dataset.collectionId
  }
}
